import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AccountAdobeManagedDetails } from '../../types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAdobeManagedAccountDetailsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAdobeManagedAccountDetailsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, managedBy?: Types.AccountManagementTypes | null, adobeOrg?: string | null } | null };


export const GetAdobeManagedAccountDetails = /*#__PURE__*/ gql`
    query GetAdobeManagedAccountDetails($accountId: ID!) {
  account(accountId: $accountId) {
    id
    ...AccountAdobeManagedDetails
  }
}
    ${AccountAdobeManagedDetails}` as unknown as DocumentNode<GetAdobeManagedAccountDetailsQuery, GetAdobeManagedAccountDetailsQueryVariables>;

          

          export const useGetAdobeManagedAccountDetailsQuery = (options?:QueryHookOptions<GetAdobeManagedAccountDetailsQuery, GetAdobeManagedAccountDetailsQueryVariables>) => useQuery(GetAdobeManagedAccountDetails, options);

          

          export type GetAdobeManagedAccountDetailsQueryOptions = QueryHookOptions<GetAdobeManagedAccountDetailsQuery, GetAdobeManagedAccountDetailsQueryVariables>;

          

          export const useGetAdobeManagedAccountDetailsLazyQuery = (options?:LazyQueryHookOptions<GetAdobeManagedAccountDetailsQuery, GetAdobeManagedAccountDetailsQueryVariables>) => useLazyQuery(GetAdobeManagedAccountDetails, options);

          

          export type GetAdobeManagedAccountDetailsQueryResult = ReturnType<typeof useGetAdobeManagedAccountDetailsQuery>;

          
